import { Storage } from "@ionic/storage";

const storage = new Storage();
const initStorage = async () => {
  await storage.create();
};

export { storage, initStorage };
